import axios from "axios";
import { api } from "./api";
import { orderEndpoints } from "../constants/endpoints";
import {
  CustomerOrder,
  SellerOrder,
  Pagination,
  OrderPayloadProps,
} from "../types/Order";
import {
  transformToCustomerOrders,
  transformToSellerOrders,
} from "../utils/orderMapping";

export type FetchOrdersProps = {
  emailId: string;
  page: number;
  limit: number;
  search?: string;
};

export const fetchOrders = async ({
  emailId,
  page,
  limit,
  search,
}: FetchOrdersProps): Promise<{
  orders: CustomerOrder[];
  pagination: Pagination;
}> => {
  try {
    const params: any = {
      //emailId,
      page,
      limit,
      search,
    };

    const response = await api.get(orderEndpoints.getOrders(emailId), {
      params,
    });

    const transformedOrders = transformToCustomerOrders(
      response.data.data.orders
    );

    return {
      orders: transformedOrders,
      pagination: response.data.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching orders by customer ID:", error);
    throw error;
  }
};

export const fetchOrdersSeller = async ({
  emailId,
  page,
  limit,
  search,
}: FetchOrdersProps): Promise<{
  orders: SellerOrder[];
  pagination: Pagination;
}> => {
  try {
    const params: any = {
      page,
      limit,
      search,
    };

    const response = await api.get(orderEndpoints.getOrders(emailId), {
      params,
    });

    const transformedOrders = transformToSellerOrders(
      response.data.data.orders
    );

    return {
      orders: transformedOrders,
      pagination: response.data.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching orders by customer ID:", error);
    throw error;
  }
};

export const createOrder = async (
  payload: OrderPayloadProps
): Promise<void> => {
  console.log("payload++", payload);
  try {
    const response = await api.post(orderEndpoints.createOrder, payload);
    console.log("Order created successfully:", response.data);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data || error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getOrderById = async (
  orderId: string | undefined
): Promise<any> => {
  try {
    const response = await api.get(`orders/${orderId}`);
    console.log("Order fetched successfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error fetching order details:", error);
    return undefined;
  }
};

export const triggerOrderPayment = async (
  orderId: string | undefined
): Promise<any> => {
  try {
    const response = await api.put(`trigger-payment/${orderId}`, {
      triggerPayment: true,
    });
    console.log("Order payment triggered successfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error triggering order payment:", error);
    return undefined;
  }
};
